"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceTemplateString = replaceTemplateString;
exports.defineFegoVariable = defineFegoVariable;
exports.hasDefineFegoVariable = hasDefineFegoVariable;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function replaceTemplateString(template, obj) {
    return template.replace(/\{(\w+)\}/g, (match, key) => {
        const res = Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : match; // 如果 key 不存在，保留原占位符
        return res; // 如果 key 不存在，保留原占位符
    });
}
/**
 * 定义fego变量
 * @param key fego变量名
 * @param value fego变量值
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function defineFegoVariable(key, value) {
    const editor = require('@futuweb/fego-editor');
    editor.app.project.setVariable(Object.assign(editor.app.project.variable, {
        [key]: value
    }));
}
/**
 * 判断fego变量是否定义
 * @param key fego变量名
 * @returns {boolean} 是否定义
 */
function hasDefineFegoVariable(key) {
    const editor = require('@futuweb/fego-editor');
    return editor.app.project.variable[key] !== undefined;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInV0aWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFDQSxzREFLQztBQVFELGdEQU9DO0FBT0Qsc0RBR0M7QUEvQkQsOERBQThEO0FBQzlELFNBQWdCLHFCQUFxQixDQUFDLFFBQWdCLEVBQUUsR0FBd0I7SUFDNUUsT0FBTyxRQUFRLENBQUMsT0FBTyxDQUFDLFlBQVksRUFBRSxDQUFDLEtBQUssRUFBRSxHQUFHLEVBQUUsRUFBRTtRQUNqRCxNQUFNLEdBQUcsR0FBRyxNQUFNLENBQUMsU0FBUyxDQUFDLGNBQWMsQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxDQUFDLG9CQUFvQjtRQUNuRyxPQUFPLEdBQUcsQ0FBQyxDQUFDLG9CQUFvQjtJQUNwQyxDQUFDLENBQUMsQ0FBQztBQUNQLENBQUM7QUFFRDs7OztHQUlHO0FBQ0gsOERBQThEO0FBQzlELFNBQWdCLGtCQUFrQixDQUFDLEdBQVcsRUFBRSxLQUFVO0lBQ3RELE1BQU0sTUFBTSxHQUFHLE9BQU8sQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO0lBQy9DLE1BQU0sQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLFdBQVcsQ0FDMUIsTUFBTSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLE9BQU8sQ0FBQyxRQUFRLEVBQUU7UUFDdkMsQ0FBQyxHQUFHLENBQUMsRUFBRSxLQUFLO0tBQ2YsQ0FBQyxDQUNMLENBQUM7QUFDTixDQUFDO0FBRUQ7Ozs7R0FJRztBQUNILFNBQWdCLHFCQUFxQixDQUFDLEdBQVc7SUFDN0MsTUFBTSxNQUFNLEdBQUcsT0FBTyxDQUFDLHNCQUFzQixDQUFDLENBQUM7SUFDL0MsT0FBTyxNQUFNLENBQUMsR0FBRyxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDLEtBQUssU0FBUyxDQUFDO0FBQzFELENBQUMifQ==